import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getLoginStatus, logout as _logout } from '../api/sso'


export const updateLoginStatus = createAsyncThunk('user/updateLoginStatus', async () => {
  return await getLoginStatus();
})


export const logout = createAsyncThunk('user/logout', async () => {
  return await _logout()
})


const initialState = {
  login: false,
  httpStatus: '',
  name: '',
  apiToken: '',
  errorMessage: '',
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoginStatus(state, action) {
      const { status, name, token, error } = action.payload
      if (status === 200) {
        state.login = true
        state.httpStatus = status
        state.name = name
        state.apiToken = token
        state.errorMessage = ''
      } else {
        state.login = false
        state.httpStatus = status
        state.name = ''
        state.apiToken = ''
        state.errorMessage = error ? error.message : ''
      }
    },
  },
  extraReducers: {
    [updateLoginStatus.fulfilled]: (state, action) => {
      if (action.payload) {
        const { status, name, token, error } = action.payload
        if (status === 200) {
          state.login = true
          state.httpStatus = status
          state.name = name
          // state.email = email
          state.apiToken = token
          state.errorMessage = ''
        } else {
          state.login = false
          state.httpStatus = status
          state.name = ''
          // state.email = ''
          state.apiToken = ''
          state.errorMessage = error ? error.message : ''
        }
      }      
    },
    [updateLoginStatus.rejected]: (state, action) => {
      const errorMessage = action.error ? action.error.message : ''
      state.login = false
      state.errorMessage = errorMessage
      console.warn('UpdateLoginStatus Error Code:', errorMessage)
    },
    [logout.fulfilled]: (state, action) => {
      state.login = false
      state.name = ''
      state.apiToken = ''
    },
    [logout.rejected]: (state, action) => {
      state.login = false
      state.name = ''
      state.apiToken = ''
    },
  },
})

export const { setLoginStatus } = userSlice.actions

export default userSlice.reducer

